import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TableActionSeverity } from 'src/app/types/misc/Severity';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-table-action',
  templateUrl: './table-action.component.html',
  styleUrls: ['./table-action.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS, ButtonModule, TooltipModule]
})
export class TableActionComponent {
  @Input() severity: TableActionSeverity = 'primary';

  @Input() tooltip?: string;

  @Input() tooltipPosition: string = 'right';

  @Input() icon: string = '';

  @Output() actionClicked = new EventEmitter<void>();

  clicked(): void {
    this.actionClicked.emit();
  }
}
